import {
  AfterContentInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { VariantCategory } from '../product-detail.component';
import { DropDownOption } from '../../../../../../../shared/ui/src/lib/shared/elements/drop-down/drop-down.component';

@Component({
  selector: 'kion-variant-selection',
  templateUrl: './variant-selection.component.html',
  styleUrls: ['./variant-selection.component.scss']
})
export class VariantSelectionComponent implements OnInit, OnChanges{
  @Input() variant: VariantCategory;
  // tslint:disable-next-line:no-output-native no-output-rename
  @Output('select') selectVariantEmitter: EventEmitter<{ code: string }[]> = new EventEmitter<{ code: string }[]>();

  options: DropDownOption[];

  ngOnInit(): void {
    this.getOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.variant) {
      if (changes.variant.currentValue !== changes.variant.previousValue) {
        this.getOptions();
      }
    }
  }

  getOptions(): void {
    this.options =  this.variant.variants.map(
      variant => {
        return {
          key: variant.variantCodes,
          value: variant.name,
          selected: variant.isActive
        }
      }
    )
  };

  selectVariant(codes: {code: string}[]) {
    this.selectVariantEmitter.emit(codes);
  }

  selectVariantFromDropDown(option: DropDownOption) {
    console.log(option);
    this.selectVariant(option.key);
  }
}
